export const Mask = ({ masked, length, value }) => {
  if (masked) {
    return (
      <span>{'•'.repeat(length)}</span>
    );
  }

  return (<span>{value}</span>);
};
